import React from 'react';
import { Field } from 'react-final-form';

export interface FieldFragmentProps {
    component: any;
    name: string;
    required?: boolean;
    suggestions?: object;
}

export default function FieldFragment({ component: Component, fieldClassName, name, ...props }: FieldFragmentProps & any) {
    return (
        <Field
            name={name}
            fieldClassName={fieldClassName}
            render={({ input: { onChange, value }, meta: { error } }) => (
                <Component {...props} error={error} name={name} setValue={onChange} value={value} />
            )}
        />
    );
}
